import React from "../../../../__snowpack__/pkg/react.js";
export const IconInfo = React.memo((props) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("title", null, "\u7F16\u7EC4 5"), /* @__PURE__ */ React.createElement("g", {
    id: "\u5957\u9910/\u5E97\u94FA\u63D0\u9192",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u5373\u5C06\u5230\u671F",
    transform: "translate(-694.000000, -93.000000)"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-5",
    transform: "translate(694.000000, 93.000000)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M7,14 C3.13359375,14 0,10.8664062 0,7 C0,3.13359375 3.13359375,0 7,0 C10.8664062,0 14,3.13359375 14,7 C14,10.8664062 10.8664062,14 7,14 L7,14 Z",
    id: "Path",
    fill: "#FAAD14",
    transform: "translate(7.000000, 7.000000) scale(1, -1) translate(-7.000000, -7.000000) "
  }), /* @__PURE__ */ React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#FFFFFF",
    x: "6.3",
    y: "2.8",
    width: "1.4",
    height: "7",
    rx: "0.7"
  }), /* @__PURE__ */ React.createElement("circle", {
    id: "\u692D\u5706\u5F62",
    fill: "#FFFFFF",
    cx: "7",
    cy: "11.2",
    r: "1"
  })))));
});
